// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-how {
  color: var(--black5);
  display: flex;
  padding-top: 1rem;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
}
@media (max-width: 768px) {
  .settings-how {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
  }
}
.settings-how.three > div {
  width: 33%;
}
.settings-how > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem 1rem;
  padding-bottom: 0;
  position: relative;
  width: 20%;
}
@media (max-width: 768px) {
  .settings-how > div:first-child {
    padding-top: 2rem;
  }
}
@media (max-width: 768px) {
  .settings-how > div {
    width: 100%;
    padding: 0.5rem 0;
    flex-direction: row;
    text-align: left;
  }
  .settings-how > div > div {
    margin-right: 1rem;
    margin-bottom: 0 !important;
  }
}
@media (max-width: 420px) {
  .settings-how > div {
    width: 100%;
    padding: 0;
    padding-bottom: 1.25rem;
  }
}
.settings-how > div:last-of-type > div:after {
  display: none;
}
.settings-how > div > div {
  min-width: 3rem;
  min-height: 3rem;
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  background: var(--purple1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .settings-how > div > div {
    min-width: 2.5rem;
    min-height: 2.5rem;
    width: 2.5rem;
    height: 2.5rem;
  }
}
.settings-how > div > div:after {
  content: "";
  position: absolute;
  top: 2.5rem;
  width: calc(100% - 2rem - 2rem - 2rem);
  height: 2px;
  background: var(--black2);
  left: calc(50% + 3rem);
}
@media (max-width: 768px) {
  .settings-how > div > div:after {
    display: none;
  }
}

.inputs-block-container {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .inputs-block-container {
    flex-direction: column;
  }
}
.inputs-block-container > div {
  width: calc(50% - 0.5rem);
}
@media (max-width: 768px) {
  .inputs-block-container > div {
    width: 100%;
  }
}

.settings-content-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 1.5rem;
}
.settings-content {
  padding: 1.25rem;
  background: var(--white);
  border-radius: 0.5rem;
  position: relative;
  width: 100%;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
}
@media (max-width: 768px) {
  .settings-content {
    padding: 1rem 1rem;
  }
  .settings-content:last-of-type {
    margin-bottom: 0 !important;
  }
}
.settings-content form {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/settings/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACF;AACE;EARF;IASI,eAAA;IACA,uBAAA;IACA,cAAA;EAEF;AACF;AACI;EACE,UAAA;AACN;AAGE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AADJ;AAIM;EADF;IAEI,iBAAA;EADN;AACF;AAII;EAhBF;IAiBI,WAAA;IACA,iBAAA;IACA,mBAAA;IACA,gBAAA;EADJ;EAGI;IACE,kBAAA;IACA,2BAAA;EADN;AACF;AAII;EA5BF;IA6BI,WAAA;IACA,UAAA;IACA,uBAAA;EADJ;AACF;AAIM;EACE,aAAA;AAFR;AAMI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAJN;AAMM;EAZF;IAaI,iBAAA;IACA,kBAAA;IACA,aAAA;IACA,cAAA;EAHN;AACF;AAKM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AAHR;AAKQ;EATF;IAUI,aAAA;EAFR;AACF;;AAUA;EACE,aAAA;EACA,8BAAA;AAPF;AASE;EAJF;IAKI,sBAAA;EANF;AACF;AAQE;EACE,yBAAA;AANJ;AAQI;EAHF;IAII,WAAA;EALJ;AACF;;AAYE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AATJ;AAYE;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,iFAAA;AAVJ;AAYI;EARF;IASI,kBAAA;EATJ;EAWI;IACE,2BAAA;EATN;AACF;AAYI;EACE,gBAAA;AAVN","sourcesContent":[".settings-how {\n  color: var(--black5);\n  display: flex;\n  padding-top: 1rem;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 0;\n  }\n\n  &.three {\n    & > div {\n      width: 33%;\n    }\n  }\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 1rem 1rem;\n    padding-bottom: 0;\n    position: relative;\n    width: 20%;\n\n    &:first-child {\n      @media (max-width: 768px) {\n        padding-top: 2rem;\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n      padding: .5rem 0;\n      flex-direction: row;\n      text-align: left;\n\n      & > div {\n        margin-right: 1rem;\n        margin-bottom: 0 !important;\n      }\n    }\n\n    @media (max-width: 420px) {\n      width: 100%;\n      padding: 0;\n      padding-bottom: 1.25rem;\n    }\n\n    &:last-of-type > div {\n      &:after {\n        display: none;\n      }\n    }\n\n    & > div {\n      min-width: 3rem;\n      min-height: 3rem;\n      width: 3rem;\n      height: 3rem;\n      border-radius: 100%;\n      background: var(--purple1);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 1rem;\n\n      @media (max-width: 768px) {\n        min-width: 2.5rem;\n        min-height: 2.5rem;\n        width: 2.5rem;\n        height: 2.5rem;\n      }\n\n      &:after {\n        content: \"\";\n        position: absolute;\n        top: 2.5rem;\n        width: calc(100% - 2rem - 2rem - 2rem);\n        height: 2px;\n        background: var(--black2);\n        left: calc(50% + 3rem);\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n\n    }\n  }\n\n}\n\n.inputs-block-container {\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n  & > div {\n    width: calc(50% - .5rem);\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n}\n\n\n.settings {\n\n  &-content-title {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    color: var(--black9);\n    margin-bottom: 1.5rem;\n  };\n\n  &-content {\n    padding: 1.25rem;\n    background: var(--white);\n    border-radius: .5rem;\n    position: relative;\n    width: 100%;\n    box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n\n    @media (max-width: 768px) {\n      padding: 1rem 1rem;\n\n      &:last-of-type {\n        margin-bottom: 0 !important;\n      }\n    }\n\n    form {\n      margin-bottom: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
